__webpack_require__.p = "/PokeDexApp/";